<template lang="html">
  <div class="logo-wrap bg-white p-3 pb-1">
    <img src="@/assets/logos_header.svg" alt="Diensten Centrum" class="w-100" />
  </div>
  <h3 class="title text-white">
    Door op akkoord te klikken, accepteert u ons privacybeleid. <br />Voor meer
    details, bezoek alstublieft
    <a
      href="https://www.sdworx.nl/nl-nl/sd-worx-online-privacy-statement"
      target="_blank"
      class="text-white"
      >ons privacybeleid</a
    >
  </h3>
  <br />
  <div class="d-grid gap-2">
    <button
      type="button"
      class="btn btn-secondary btn-lg"
      @click="saveQuestionGdpr()"
    >
      <span>Akkoord</span>
    </button>
  </div>
</template>

<script>
export default {
  name: "QuestionGdprScreen",
  data: () => ({}),
  computed: {},
  methods: {
    addRemoveAnswer(answer) {
      if (this.checkedAnswers.indexOf(answer) !== -1) {
        this.checkedAnswers.splice(this.checkedAnswers.indexOf(answer), 1);
      } else {
        this.checkedAnswers.push(answer);
      }
    },
    answerChecked(answer) {
      if (this.checkedAnswers.indexOf(answer) !== -1) {
        return true;
      }
      return false;
    },
    saveQuestionGdpr() {
      let code = this.createCode(5);
      this.$store.commit("setCode", code);
      this.$store.commit("setQuestionGdpr", "true");
      let data = {};
      data.name = this.$store.getters.getFirstName;
      data.last_name = this.$store.getters.getLastName;
      data.phone = this.$store.getters.getPhone;
      data.email = this.$store.getters.getEmail;
      data.company = this.$store.getters.getCompany;
      data.job_position = this.$store.getters.getJobposition;
      data.question_one = this.$store.getters.getQuestionOne;
      data.question_two = this.$store.getters.getQuestionTwo;
      data.question_three = this.$store.getters.getQuestionThree;
      data.question_four = this.$store.getters.getQuestionFour;
      data.code = code;
      this.$store.dispatch("saveVisitor", data);
    },
    createCode(length) {
      let result = "";
      const characters = "0123456789";
      const charactersLength = characters.length;
      let counter = 0;
      while (counter < length) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
        counter += 1;
      }
      return result.toString();
    },
  },
};
</script>

<style lang="css" scoped>
.logo-wrap {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  background: rgba(40, 110, 187, 0.9);
  z-index: 10;
}

.logo-wrap img {
  display: block;
}

h2 {
  font-size: 40px;
}
.bg-field {
  color: #fdf7ea !important;
}
</style>
